import React, { useState } from 'react';
import { useAdmin } from '../../context/AdminContext';
import CategoryForm from './CategoryForm';
import '../admin/AdminComponents.css';

const CategoriesManagement = () => {
  const { categories, deleteCategory } = useAdmin();
  const [editingCategory, setEditingCategory] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleEdit = (category) => {
    setEditingCategory(category);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (id === 'all') {
      alert('Cannot delete the "All" category');
      return;
    }
    if (window.confirm('Are you sure you want to delete this category?')) {
      try {
        await deleteCategory(id);
      } catch (error) {
        alert(error.message || 'Failed to delete category');
      }
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingCategory(null);
  };

  const sortedCategories = categories
    .map((category, index) => ({ category, index }))
    .sort((a, b) => {
      const aOrder = Number(a.category.displayOrder ?? a.category.display_order ?? a.index);
      const bOrder = Number(b.category.displayOrder ?? b.category.display_order ?? b.index);
      return aOrder - bOrder || a.category.name.localeCompare(b.category.name) || a.index - b.index;
    })
    .map(({ category }) => category);

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <h2 className="admin-section-title">Categories Management</h2>
        <div className="admin-section-actions">
          <button
            className="admin-button primary"
            onClick={() => {
              setEditingCategory(null);
              setShowForm(true);
            }}
          >
            Add Category
          </button>
        </div>
      </div>
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Display Order</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sortedCategories.map((category) => (
              <tr key={category.id}>
                <td>{category.id}</td>
                <td>{category.name}</td>
                <td>{category.displayOrder ?? category.display_order ?? 0}</td>
                <td>
                  <div className="admin-table-actions">
                    <button
                      className="admin-icon-button"
                      onClick={() => handleEdit(category)}
                      title="Edit"
                    >
                      ✎
                    </button>
                    {category.id !== 'all' && (
                      <button
                        className="admin-icon-button danger"
                        onClick={() => handleDelete(category.id)}
                        title="Delete"
                      >
                        ×
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>

        </table>

      </div>


      {showForm && (
        <CategoryForm
          category={editingCategory}
          onClose={handleFormClose}
        />

      )}
    </div>

  );
};

export default CategoriesManagement;
